import { clearHighlight } from "../direct.js";

export let FirstMenuAxis = {
  name: 'axis',
  title: 'Edit axis',
  shortcut: 'x'
}
export function queryAxisLabelElements(view, role, li, ti, field) {
  // fronto-label-axis-${role:x, y, row, column} F_layer_${li}__axisLabel_${ti}_${field}
  // replacement
  let axis_label_query = `replacement.fronto-label-axis-${role}.F_layer_${li}__axisLabel_${ti}_${field}`;
  return Array.from(view.querySelectorAll(axis_label_query)).filter(
    (d) => d !== undefined
  );
}
export function queryAxisGridGroups(view, role) {
  let grids = view.querySelectorAll("g.mark-rule.role-axis-grid");
  return Array.from(grids).filter((grid) => {
    return role == "y"
      ? grid.children[0].getAttribute("y2") === "0"
      : grid.children[0].getAttribute("x2") === "0";
  });
}
export function queryAxisGraphcialElements(view, role, includeText) {
  let groups = view.querySelectorAll("g.role-axis");
  let validGroups = Array.from(groups).filter((group) => {
    return (
      group.getAttribute("aria-roledescription") === "axis" &&
      group
        .getAttribute("aria-label")
        .startsWith(role?.toUpperCase() + "-axis")
    );
  });
  let elements = validGroups.map((group) => {
    let output = Array.from(
      group.querySelectorAll("g.mark-rule.role-axis-tick > line")
    );
    output.push(
      ...Array.from(
        group.querySelectorAll("g.mark-rule.role-axis-domain > line")
      )
    );
    if (includeText) {
      output.push(
        ...Array.from(
          group.querySelectorAll("g.mark-text.role-axis-label > text")
        )
      );
    }
    return output;
  });
  return elements.filter((d) => d !== undefined && d.length > 0);
}

export function findAxis(uid, axis, cls) {
  let vObj = document.querySelector("#view-" + uid);
  let cls_name = { find: "dupo-g-found", hide: "dupo-g-hidden", unhide: "dupo-g-hidden" }[cls];
  let axisLabelElements = axis.textDesign
    ?.map((text) =>
      queryAxisLabelElements(
        vObj,
        axis.subrole,
        text.layerIndex,
        text.textIndex,
        axis.field || axis.aggregate
      )
    )
    .filter((d) => d !== undefined && d.length > 0);
  axisLabelElements?.forEach((group) => {
    if (cls === "unhide") { group?.forEach((e) => e?.classList?.remove(cls_name)); }
    else { group?.forEach((e) => e?.classList?.add(cls_name)); }
  });
  let axisGridGroups = queryAxisGridGroups(vObj, axis.subrole);
  axisGridGroups?.forEach((grid) => {
    Array.from(grid.children).forEach((g) => {
      if (cls === "unhide") { g?.classList?.remove(cls_name); }
      else { g?.classList?.add(cls_name); }
    });
  });
  let axisGraphicalGroups = queryAxisGraphcialElements(
    vObj,
    axis.subrole,
    axisLabelElements.length == 0
  );
  axisGraphicalGroups.forEach((group) => {
    if (cls === "unhide") { group.forEach((e) => e?.classList?.remove(cls_name)); }
    else { group.forEach((e) => e?.classList?.add(cls_name)); }
  });
}
export function unfindAxis() {
  clearHighlight();
}